import React, { useEffect, useState, useCallback } from 'react';
import { errorLogsAPI } from '../services/api';

const ErrorLogs = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [limit, setLimit] = useState(50);
  const [error, setError] = useState('');

  const loadLogs = useCallback(async () => {
    setLoading(true);
    setError('');
    try {
      const res = await errorLogsAPI.list(limit);
      const data = res.data?.logs || res.data?.data || [];
      setLogs(Array.isArray(data) ? data : []);
    } catch (e) {
      setError(e?.response?.data?.error || e.message || 'Erro ao carregar logs');
    } finally {
      setLoading(false);
    }
  }, [limit]);

  useEffect(() => { loadLogs(); }, [loadLogs]);

  return (
    <div className="error-logs-page">
      <div className="page-header" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h2>🪵 Logs de Erro (Worker)</h2>
        <div>
          <label style={{ marginRight: '0.5rem' }}>Limite:</label>
          <input type="number" value={limit} min={1} max={500} onChange={(e) => setLimit(Number(e.target.value))} style={{ width: '80px' }} />
          <button className="page-btn" onClick={() => loadLogs()} style={{ marginLeft: '0.5rem' }}>Atualizar</button>
        </div>
      </div>

      {loading && (
        <div className="loading" style={{ marginTop: '1rem' }}>Carregando logs...</div>
      )}
      {error && (
        <div className="error" style={{ marginTop: '1rem', color: '#c00' }}>{error}</div>
      )}

      {!loading && !error && (
        <div className="logs-table" style={{ marginTop: '1rem' }}>
          <table className="table" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>ID</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Data</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Rota</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Método</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Mensagem</th>
                <th style={{ textAlign: 'left', borderBottom: '1px solid #ddd', padding: '8px' }}>Stack</th>
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 ? (
                <tr><td colSpan={6} style={{ padding: '12px' }}>Sem logs de erro.</td></tr>
              ) : (
                logs.map((log) => (
                  <tr key={log.id}>
                    <td style={{ padding: '8px' }}>{log.id}</td>
                    <td style={{ padding: '8px' }}>{log.created_at}</td>
                    <td style={{ padding: '8px' }}>{log.route}</td>
                    <td style={{ padding: '8px' }}>{log.method}</td>
                    <td style={{ padding: '8px' }}>{log.message}</td>
                    <td style={{ padding: '8px', maxWidth: '400px', whiteSpace: 'pre-wrap' }}>{log.stack}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default ErrorLogs;